import { render } from "./ClientDetail.vue?vue&type=template&id=c558507a&scoped=true"
import script from "./ClientDetail.vue?vue&type=script&lang=js"
export * from "./ClientDetail.vue?vue&type=script&lang=js"

import "./ClientDetail.vue?vue&type=style&index=0&id=c558507a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c558507a"]])

export default __exports__